import { ArrowDropDownCircle, Forward5, Layers, LocationSearching, Toll } from "@mui/icons-material";
import { Box, Grid, Typography, Select, MenuItem, Card,Tabs, Tab, Chip } from "@mui/material";
import { styled } from "@mui/system";
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer } from "recharts";
import { useState } from "react";
import buybarg from "../../assets/buybarg.png";
import supbarg from "../../assets/supbarg.png";
import ior from "../../assets/ior.png";
import dos from "../../assets/dos.png";
import eb from "../../assets/eb.png";
import sourceicon from "../../assets/source.png";
import { Tooltip as MUITooltip } from "@mui/material";
import { useAtom } from 'jotai';
import { selectedCategoryAtom } from './atoms';

const CustomBox = styled(Box)({
  width: "100%",
  padding: "4px",
  gap: "16px",
  // border: "1px solid #FFFFFF0F",
  // borderRadius: "10px",
  marginTop: "2rem",
  display: "flex",
  flexDirection: "column",
  // backgroundColor: "#FFFFFF08",
});

const CustomCard = styled(Card)({
  padding: "16px",
  backgroundColor: "transparent",
  color: "white",
  height: "100%",
  border:'1px solid #FFFFFF0F',
  borderRadius: "8px",
  display: "flex",
  flexDirection: "column",
  overflow: 'hidden', // Add this
  wordWrap: 'break-word' // Add this
});

export const PorterForces = ({ porterForces, catandSpend, marketImplications, selectedL3Category }) => {
  const [selectedCategory, setSelectedCategory] = useAtom(selectedCategoryAtom);
  const [activeTab, setActiveTab] = useState('implications');

  console.log('implications is', marketImplications);
  
  // Get the main category name (Metal Tubes in this case)
  const mainCategory = Object.keys(porterForces)[0];

    // Get the correct market implication based on category and subcategory
    const currentMarketImplication = marketImplications?.[mainCategory]?.[selectedL3Category];

  
  const getForceTitle = (index) => {
    const titles = [
      "Bargaining Power of Buyer",
      "Bargaining Power of Supplier",
      "Entry Barriers",
      "Difficulty of Substitution",
      "Intensity of Rivalry",
    ];
    return titles[index];
  };

  const scoreColors = {
    'Low': '#BE3FF50F',         // Green
    'Low-Medium': '#BE3FF51F',  // Light Green
    'Medium': '#BE3FF53D',      // Yellow
    'Medium-High': '#BE3FF57A', // Orange
    'High': '#BE3FF5B2'         // Red
  };

  const getForceImage = (index) => {
    const images = [buybarg, supbarg, eb, dos, ior];
    return images[index];
  };

  const scoreMapping = {
    Low: 1,
    "Low-Medium": 2,
    Medium: 3,
    "Medium-High": 4,
    High: 5,
  };

  // Update radar data to use the nested structure
  const radarData = selectedL3Category && porterForces[mainCategory]?.[selectedL3Category]
    ? porterForces[mainCategory][selectedL3Category].map((force, index) => ({
        force: getForceTitle(index),
        score: scoreMapping[force.score] || 0,
      }))
    : [];

  return (
    <>
                  <Typography
                    color="#FFFFFF99"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      fontSize: "1rem",
                      mb: 4
                    }}
                  >
                    <Layers
                      sx={{
                        mr: 0.25,
                        height: "15px",
                        width: "15px",
                        color: "#FFFFFF99",
                      }}
                    />
                    <span
                      style={{
                        fontStyle: "Roboto",
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                    >
      Porter's 5 Forces
      </span>
    </Typography>
    <Grid container spacing={2} sx={{display:'flex',flexDirection:'column', alignItems:'center' }}>
      {/* <Grid item xs={2} md={2}> */}
      <Box sx={{ width: '100%', height: '200px', alignItems:'center' }}>
      <ResponsiveContainer width="100%" height={200}> 
            <RadarChart data={radarData} >
              <PolarGrid />
              <PolarAngleAxis
                dataKey="force"
                stroke="#FFFFFF"
                tick={{ fontSize: 11 }}
              />
              <PolarRadiusAxis
                angle={30}
                domain={[0, 5]}
                stroke="#FFFFFF"
                tick={false}
                ticks={[0, 1, 2, 3, 4, 5]}
                tickLine={false}
                axisLine={false}
              />
              <Radar
                name="Score"
                dataKey="score"
                stroke="#BE3FF5"
                strokeWidth={2.01}
                fill="#BE3FF54D"
                fillOpacity={0.6}
                dot={{ r: 2, fill: '#BE3FF5', stroke: '#BE3FF54D', strokeWidth: 1 }}
              />
            </RadarChart>
          </ResponsiveContainer>
        </Box>
 
      {/* </Grid> */}

      {/* Force Descriptions */}
     {/* Force Descriptions */}
<Grid item xs={12} md={12}>
<Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
  <Tabs 
    value={activeTab}
    onChange={(e, newValue) => setActiveTab(newValue)}
    sx={{
      width: '190px',
      height: '35px',
      borderRadius: '8px',
      fontStyle: 'Roboto',
      fontSize: '12px',
      padding: '4px',
      gap: '8px',
      backgroundColor: '#FFFFFF0F',
      minHeight: 'unset',
      color:'white',
      '& .MuiTab-root': {
        minHeight: 'unset',
        height: '27px',
        padding: '6px 8px',
        textTransform: 'none',
        color: '#FFFFFF99',
        gap: '8px',
        borderRadius: '4px',
        color:'white'
      },
      '& .Mui-selected': {
        backgroundColor: '#FFFFFF4D',
        width: '86px',
        color: 'white !important',
      },
      '& .MuiTabs-indicator': {
        display: 'none'
      }
    }}
  >
    <Tab value="implications" label="Implications" />
    <Tab value="score" label="Score" />
  </Tabs>
</Box>

{activeTab === 'implications' && (
  <Box sx={{ 
    p: 2, 
    backgroundColor: '#FFFFFF0F', 
    borderRadius: '8px',
    border: '1px solid #FFFFFF0F',
    padding: '16px',
    gap: '16px',
    minHeight: '100px',
    width: '100%',
    position: 'relative',
    marginBottom: '12px',
  }}>
    <Typography sx={{ 
      fontSize: '14px', 
      color: '#FFFFFFCC',
      width: '100%'
    }}>
      {Array.isArray(currentMarketImplication) ? 
        currentMarketImplication.map((item, index) => (
          <Box key={index}>
            <Box sx={{
              marginBottom: "4px",
              display: "flex",
              alignItems: "flex-start",
            }}>
              <Typography
                component="span"
                sx={{
                  marginRight: "8px",
                  color: "#FFFFFF",
                  fontSize: "10px",
                  lineHeight: "20px",
                }}
              >
                •
              </Typography>
              {item.trim()}
            </Box>
          </Box>
        )) 
        : 'No market implications available'
      }
    </Typography>
  </Box>
)}

  {activeTab === 'score' && (
    <Grid container spacing={2}
    sx={{
      marginBottom: '12px'
    }}>
      {porterForces[mainCategory]?.[selectedL3Category]?.map((force, index) => (
        <Grid
          item
          xs={6}
          md={index === 4 ? 12 : 6}
          key={index}
          sx={{
            width: index === 4 ? '100%' : 'auto',
            maxWidth: index === 4 ? '100%' : '50%'
          }}
        >
          <CustomCard>
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
              <img
                src={getForceImage(index)}
                alt={getForceTitle(index)}
                style={{
                  width: "30px",
                  height: "30px",
                  marginRight: "8px",
                  borderRadius: "50%",
                }}
              />
              <Typography sx={{ fontSize: "12px", fontStyle: "Roboto" }}>
                {getForceTitle(index)}
              </Typography>
              <Box
                sx={{
                  backgroundColor: force.score !== "N/A" ? scoreColors[force.score] : "#FFFFFF0F",
                  borderRadius: "4px",
                  padding: "4px",
                  ml: 1,
                }}
              >
                {force.score !== "N/A" && (
                  <Typography
                    sx={{ fontSize: "10px", color: "#FFFFFF", fontStyle: "Roboto" }}
                  >
                    {force.score}
                  </Typography>
                )}
              </Box>
            </Box>
            <Typography
              sx={{
                fontSize: "12px",
                color: "#FFFFFF99",
                fontStyle: "Roboto",
              }}
            >
              {force.genai_description}
            </Typography>
          </CustomCard>
        </Grid>
      ))}
    </Grid>
  )}


</Grid>

    </Grid>
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}> {/* Parent container */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px',
                        border: "1px solid transparent",
                        borderRadius: "6px",
                        marginBottom: "8px",
                        padding: "2px",
                        alignItems: "center",
                        justifyContent: "center",
                        alignContent: "center",
                        width: "150px",
                        // marginTop: '6px',
                 }}>
                  <Typography style={{ 
                    color: 'white', 
                    fontSize: '9px',
                    fontStyle: 'Roboto',
                    fontWeight: 300 
                  }}>
                    <i>Source:</i>
                  </Typography>
                  <MUITooltip title="source" arrow placement="right">
                    {/* <Chip
                      label={sourceCitation}
                      icon={
                        <img
                          src={sourceicon}
                          alt="icon"
                          style={{
                            width: "9px",
                            height: "9px",
                          }}
                        />
                      }
                      sx={{
                        padding: "2px",
                        height: "20px", 
                        border: "1px solid",
                        borderRadius: "900px",
                        fontStyle: "italic",
                        marginTop: "4px",
                        fontSize: "9px",
                        fontWeight: 300,
                        color: "white",
                        backgroundColor: "#FFFFFF1F",
                        marginBottom: "8px",
                        "& .MuiChip-icon": {
                          color: "white",
                        },
                      }}
                    /> */}
                    <Typography
                    sx={{
                      color: 'white', 
                      fontSize: '9px',
                      fontStyle: 'Roboto',
                      fontWeight: 300 
                }}
                  
                    >
                     Beroe/Market sources
                
                    </Typography>
                
                  </MUITooltip>
                </div>
                </div>
    </>
  );
};
